import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { Subtitle1 } from '@src/elements/typography/typography'

import { Legend } from '@src/components/legend/legend'
import { Chart } from '@src/components/chart/chart'
import { ErrorScreen } from '@src/components/error-screen/error-screen'
import { SCORE_BULLET_COLOR, SCORE_TYPES } from '@src/util/constants'
import { getChartSeriesForScores } from '@src/util/functions'
import { getKeyByView } from '@src/util/translation'

@Component
export class ExerciseHistory extends Vue {

  @Prop({ required: true })
  private scores: {
    tempoScores: [string, number][],
    precisionScores: [string, number][],
    rangeScores: [string, number][],
    pixScores: [string, number][],
    startDate: '',
    endDate: '',
    totalDays: number
  }

  private selectedFilters: string[] = []
  private portraitMatch: MediaQueryList = window.matchMedia('(orientation: portrait)')

  constructor () {
    super()
    this.selectedFilters = Object.assign([], SCORE_TYPES) || /* istanbul ignore next: Object.assign always returns the array */ []
  }

  mounted () {
    this.$nextTick(() => {
      // @ts-ignore
      this.portraitMatch.addEventListener('change', this.redrawChartUsingFiltersUpdate)
    })
  }

  beforeDestroy () {
    // @ts-ignore
    this.portraitMatch.removeEventListener('change', this.redrawChartUsingFiltersUpdate)
  }

  redrawChartUsingFiltersUpdate () {
    const legendItem = document.getElementById(SCORE_TYPES[0])
    // @ts-ignore
    legendItem.click()
    setTimeout(() => {
      // @ts-ignore
      legendItem.click()
    }, 500)

  }

  filter (measurementType) {
    let index = this.selectedFilters.indexOf(measurementType)
    if (index >= 0) {
      this.selectedFilters.splice(index, 1)
    } else {
      this.selectedFilters.push(measurementType)
    }
  }

  render (h: CreateElement) {
    if (!this.scores.totalDays) {
      return <ErrorScreen icon='brand/empty-graph' message={this.$t('PAGE.MEMBERS.TRAINING.HISTORY.EMPTY_GRAPH_HISTORY')} />
    } else {
      const firstDate = new Date(this.scores.startDate).getTime()
      const lastDate = new Date(this.scores.endDate).getTime()
      let oneDayInMilliseconds = 1000 * 60 * 60 * 24 // milliseconds * seconds * minutes * hours
      let tickInterval = (lastDate - firstDate) / (this.scores.totalDays > 1 ? this.scores.totalDays - 1 : 1) // maximum 10 dates labels will be showed
      if (tickInterval < oneDayInMilliseconds) {
        tickInterval = oneDayInMilliseconds
      }

      return (
        <div class='measurements-section'>
          <Subtitle1 class='title'>{this.$t('HISTORY')}</Subtitle1>
          <div class='visible-on-mobile'>
            <Legend select={this.filter} items={
              SCORE_TYPES.slice(0, SCORE_TYPES.length / 2).map(item => {
                return {
                  type: item,
                  label: this.$t(getKeyByView(`PAGE.MEMBERS.TRAINING.HISTORY.${item.toUpperCase()}`)),
                  color: SCORE_BULLET_COLOR[item],
                  disabled: !this.selectedFilters.includes(item)
                }
              })
            } />
            <Legend select={this.filter} items={
              SCORE_TYPES.slice(SCORE_TYPES.length / 2, SCORE_TYPES.length).map(item => {
                return {
                  type: item,
                  label: this.$t(getKeyByView(`PAGE.MEMBERS.TRAINING.HISTORY.${item.toUpperCase()}`)),
                  color: SCORE_BULLET_COLOR[item],
                  disabled: !this.selectedFilters.includes(item)
                }
              })
            } />
          </div>
          <div class='legend-wrapper' ref='legend'>
            <Legend select={this.filter} items={
              SCORE_TYPES.map(item => {
                return {
                  type: item,
                  label: this.$t(`PAGE.MEMBERS.TRAINING.HISTORY.${item.toUpperCase()}`),
                  color: SCORE_BULLET_COLOR[item],
                  disabled: !this.selectedFilters.includes(item)
                }
              })
            } />
          </div>

          <Chart chartId='exerciseHistoryChart' series={getChartSeriesForScores(this.selectedFilters, this.scores, this)}
                 tooltipPointFormat={`<div>{point.y} ${this.$t('PAGE.MEMBERS.TRAINING.HISTORY.POINTS').toString().toUpperCase()}</div>`}
                 maxOY={100}
                 emptyGraphMessage={this.$t('PAGE.MEMBERS.TRAINING.HISTORY.EMPTY_GRAPH_HISTORY')}
                 labelStyle={{ style: { color: '#212121', fontSize: '0.5rem' }, allowOverlap: false }}
                 tickInterval={tickInterval} // milliseconds * seconds * minutes * hours
          />

      </div>)
    }
  }
}
